import { createServiceAccount } from './createServiceAccount';
import { downloadServiceAccounts } from './downloadServiceAccounts';
import { fetchServiceAccount } from './fetchServiceAccount';
import { fetchServiceAccounts } from './fetchServiceAccounts';
import { getServiceAccountGiftCredits } from './getServiceAccountGiftCredits';
import { updateServiceAccount } from './updateServiceAccount';

export const serviceAccountService = {
  createServiceAccount,
  downloadServiceAccounts,
  fetchServiceAccount,
  fetchServiceAccounts,
  getServiceAccountGiftCredits,
  updateServiceAccount,
};
